import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  today: [], // Store the entire API response here
  fundloads: [],
  fundloadslist: [],
  Dashboardpayoutslist: [],
};

const DashbordSlice = createSlice({
  name: "Dashboard",
  initialState,
  reducers: {
    Todaypayouts: (state, action) => {
      state.today = action.payload; // Store the entire API response
    },
    LastfunloadHistry: (state, action) => {
        state.fundloads = action.payload; // Store the entire API response
    },
    funloadHistry: (state, action) => {
        state.fundloadslist = action.payload; // Store the entire API response
    },
    Dashboardpayoutshistry: (state, action) => {
      state.Dashboardpayoutslist = action.payload; // Store the entire API response
  },

  },
});

export const { Todaypayouts , LastfunloadHistry , funloadHistry,Dashboardpayoutshistry } = DashbordSlice.actions;
export default DashbordSlice.reducer;